import React, { useEffect, useState } from 'react'
import Tabs from '../common/Tabs'
import Kpis from '../../../partials/Kpis'
import Media from '../../../partials/Media'
import Button from '../../../partials/Button'
import RangeVertical from '../../../partials/UI/Range/Vertical'
import "./Link.scss"
import TabItem from '../../../partials/TabsContainer/TabItem.js'

const Link = (props) => {

    const { data, onComplete } = props
    const [ view, setView ] = useState()
    const [ selectedTab, setSelectedTab ] = useState()
    const [ exerciseDecisions, setExerciseDecisions ] = useState([])
    const [ simulationButton, setSimulationButton ] = useState()
    useEffect(() => {

        if(!view) setView('tabs')                                                  
        if(!selectedTab) setSelectedTab(0)

    }, []) 

    const onTabSelectHandle = (selected) =>{
        setSelectedTab(selected)
    }
    const onTabsComplete = () => {
        setView('exercise')
    }

    function pushToDecisions(arr, obj) {
        
        if(arr){
            const index = arr.findIndex((e) => e.name === obj.name);
        
            if (index === -1) {
                arr.push(obj);
            } else {
                arr[index] = obj;
            }
            return arr
        }
        else{
            return [obj]
        }
        
        
    }

    const handleRangeCallback = (exercise, rangeValue) => {
    
        const decision = { name: exercise.name, value: rangeValue }
        const added = pushToDecisions(exerciseDecisions, decision)
        setExerciseDecisions([...added])

        if(added.length === data.exercises.length){
            setSimulationButton(true)
        }

    }
    return (
        <div className="link-container">
            
            <div className="link-body">
            { view === 'tabs' && <Tabs data={data.tabs} onComplete={onTabsComplete} /> }
            { view === 'exercise' && 
                <>
                    <div className="link-exercises" >
                        <Tabs data={data.exercises} selectedIndex={selectedTab} onSelect={onTabSelectHandle} onComplete={onTabsComplete}>
                            
                            { data.exercises.map((exercise, index) => {
                                
                                const selected = selectedTab === index ? 'selected' : ''
                                
                                const decision = exerciseDecisions.find(o => o.name === exercise.name)

                                return (
                                    <TabItem key={index} className='link-exercise flex' selected={selected} >
                                        {exercise.media && 
                                            <div className="tabs-container-column media">
                                                <Media {...exercise.media} />                   
                                            </div>
                                        }

                                        {exercise.content &&
                                            <div className="tabs-container-column ">
                                                <h2>{exercise.name}</h2>
                                                {
                                                    exercise.content.map((content, index) => (
                                                        <div key={index}>
                                                            <h3>{content.header}</h3>
                                                            <p>{content.paragraph}</p>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                        }
                                        
                                            <div className="tabs-container-column input-range">

                                                <RangeVertical 
                                                    min={exercise.range.min} 
                                                    max={exercise.range.max}
                                                    value={decision ? decision.value : 0}
                                                    buttonText={exercise.range.button}
                                                    callback={(rangeValue) => handleRangeCallback(exercise,rangeValue)} 
                                                />
                                               
                                            </div>
                                        
                                    </TabItem>
                                )
                            }
                            )}

                        </Tabs> 
                        <div className="exercises-decisions">
                            <p>
                                Your decisions will appear here as you make them for each category
                            </p>
                            {exerciseDecisions && <div>
                                
                                {exerciseDecisions.map((exerciseDecision, index) => (
                                    <div key={index}>{exerciseDecision.name}: <strong>{exerciseDecision.value}</strong> </div>
                                ))}
                            </div>
                            }
                            {simulationButton &&  <Button text={'Test Decisions'} onClick={() => onComplete(exerciseDecisions)}/> }
                        </div>
                    </div>
                    <Kpis kpis={data.kpis} />
                </>
            }
            
            </div>
        </div>
    );
}

export default Link